module.exports = __webpack_public_path__ + "static/media/10sec_backward-512.2190707b.png";